import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControlName } from '@angular/forms';
import { of, ReplaySubject, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { format } from 'date-fns';
import { CardStyleRendererStringTypeComponent } from './card-style-renderer-type-string.component';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { JSONSchema7 } from 'json-schema';
import { JSONSchema7Extensions } from '@interfaces/interfaces';

@Component({
	selector: 'app-card-style-date-renderer',
	templateUrl: './card-style-renderer-type-date.component.html',
	styleUrls: ['./card-style-renderer-type-date.component.scss']
})
export class CardStyleRendererDateTypeComponent extends CardStyleRendererStringTypeComponent implements OnInit, OnDestroy, OnChanges {

	public initialDate: Date | null;
	@Input() schema: JSONSchema7 & JSONSchema7Extensions & { initialDate: string };

	@ViewChild(FormControlName)
	set formControlName(formControlName: FormControlName) {
		this.formControlName$.next(formControlName);
	}
	private formControlName$ = new ReplaySubject<FormControlName>(1);

	private subscription = new Subscription();

	dateFormat: string;

	constructor(private nzI18N: NzI18nService) {
		super();

		const dateLocale = nzI18N.getDateLocale();
		switch (dateLocale?.code) {
			case 'de':
				this.dateFormat = 'dd.MM.yyyy';
				break;
			default:
			case 'en-US':
				this.dateFormat = 'MM/dd/yyyy';
				break;
		}
	}

	ngOnInit(): void {
		super.ngOnInit();

		const dateTransform$ = this.formControlName$.pipe(
			switchMap(formControlName => {
				return formControlName.control.valueChanges.pipe(
					switchMap(value => of([value, formControlName])),
				);
			}),
			filter(() => this.format === 'date'),
		);

		this.subscription.add(dateTransform$.subscribe(([value, formControlName]) => {
			if (value instanceof Date) {
				const date = value as Date;
				if (date.toString() !== 'Invalid Date') {
					const isoDate = format(date, 'yyyy-MM-dd');
					formControlName.control.setValue(isoDate, { emitEvent: false });
				}
			}
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);
		if (changes.schema) {
			if (this.schema?.initialDate) {
				// '2002-01-01' wird zu '2002'
				if (Number.parseInt(this.schema.initialDate).toString().length === this.schema.initialDate.length) {
					this.initialDate = new Date(Date.now() + Number.parseInt(this.schema.initialDate));
				}
				else {
					this.initialDate = new Date(this.schema.initialDate);
				}
			} else {
				this.initialDate = null;
			}
		}
	}
}
